export default function GameRules() {
  return (
    <div className="rules">
      <p>Color every cell so that no two touching cells share a color.</p>
      <p>Left Click / Tap to Paint.</p>
      <p>Right Click / Hold to Erase.</p>
    </div>
  );
}
